export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - MAÇÃ.ec67034e.pdf";